import { elementText } from "@/lib/stickerDesign";

const EXACT = { WebkitPrintColorAdjust: "exact", printColorAdjust: "exact", pointerEvents: "none", position: "absolute" };

const Decor = ({ d, logo }) => {
  if (!d) return null;
  const s = `${d.stripe_size}in`;
  const stripe = { top: { left: 0, right: 0, top: 0, height: s }, bottom: { left: 0, right: 0, bottom: 0, height: s }, left: { top: 0, bottom: 0, left: 0, width: s }, right: { top: 0, bottom: 0, right: 0, width: s } }[d.stripe];
  return (
    <>
      {d.logo_bg && logo && <img src={logo} alt="" draggable={false} style={{ ...EXACT, inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: d.logo_bg_opacity ?? 0.25 }} data-testid="sticker-logo-bg" />}
      {stripe && <div style={{ ...EXACT, ...stripe, background: d.stripe_color }} data-testid="sticker-stripe" />}
      {d.border && <div style={{ ...EXACT, inset: 0, border: `${d.border_width}pt solid ${d.border_color}` }} data-testid="sticker-border" />}
    </>
  );
};

export default function StickerLabel({ sheet, elements, decor, data, biz, logo, selected, onPointerDown, outline }) {
  return (
    <div style={{ position: "relative", width: `${sheet.label_w}in`, height: `${sheet.label_h}in`, overflow: "hidden", fontFamily: "Arial, sans-serif", color: "#000",
      outline: outline ? "1px dashed #9ca3af" : "none" }} data-testid="sticker-label">
      <Decor d={decor} logo={logo} />
      {elements.map((el, k) => {
        const style = { position: "absolute", left: `${el.x}in`, top: `${el.y}in`, whiteSpace: "nowrap", lineHeight: 1.1, fontSize: `${el.size}pt`,
          fontWeight: el.bold ? 700 : 400, fontStyle: el.italic ? "italic" : "normal", color: el.color || "#000", fontFamily: el.font ? `"${el.font}", Arial, sans-serif` : undefined, cursor: onPointerDown ? "move" : "default", userSelect: "none",
          outline: selected === k ? "1.5px solid #10b981" : onPointerDown ? "1px dotted rgba(16,185,129,.5)" : "none" };
        if (el.key === "logo") {
          return logo ? <img key={k} src={logo} alt="" draggable={false} style={{ ...style, height: `${el.size / 72}in`, maxWidth: el.max_w ? `${el.max_w}in` : "none", objectFit: "contain" }} onPointerDown={onPointerDown && ((e) => onPointerDown(e, k))} data-testid="sticker-logo" />
            : onPointerDown ? <span key={k} style={{ ...style, fontSize: "7pt", border: "1px dashed #999", padding: 2 }} onPointerDown={(e) => onPointerDown(e, k)}>Logo</span> : null;
        }
        return <span key={k} style={style} onPointerDown={onPointerDown && ((e) => onPointerDown(e, k))} data-testid={`sticker-el-${el.key}`}>{elementText(el, data, biz)}</span>;
      })}
    </div>
  );
}
